import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import UserContext, { UserProvider } from './context/user.jsx';

import SignInPage from './pages/sign_in.jsx';
import Dashboard from './pages/dashboard.jsx';
import DashboardHome from './pages/dashboard_home.jsx';
import DashboardFileManager from './pages/dashboard_file_manager.jsx';
import DashboardEra from './pages/dashboard_era.jsx';
import DashboardSections from './pages/dashboard_sections.jsx';
import DashboardSection from './pages/dashboard_section.jsx';
import DashboardPopups from './pages/dashboard_popups.jsx';
import DashboardPopup from './pages/dashboard_popup.jsx';
import DashboardMaps from './pages/dashboard_maps.jsx';
import DashboardMap from './pages/dashboard_map.jsx';
import AmaMediaEntries from './pages/ama_media_entries.jsx';
import AmaMediaSettings from './pages/ama_media_settings.jsx';
import AmaMediaStats from './pages/ama_media_stats.jsx';
import Backup from './pages/backup.jsx';
import { ModalsProvider } from './context/modals.jsx';

const Index = () => {
	const navigate = useNavigate();
	const user_context = useContext(UserContext);

	useEffect(() => {
		if (!user_context.loaded) return;
		
		if (!user_context.user) {
			navigate('/sign_in');
		} else {
			navigate('/dashboard');
		}
	}, [user_context.loaded, user_context.user, navigate]);

	if (!user_context.loaded) return <p>Loading...</p>;

	return null;
};

export default function App() {
	return (
		<Router>
			<ModalsProvider>
				<UserProvider>
					<Routes>
						<Route exact path="/" element={<Index element />} />
						<Route path="/sign_in" element={<SignInPage />} />
						<Route path="/dashboard" element={<Dashboard />}>
							<Route path="" element={<DashboardHome />} />
							<Route path="ama_media/entries" element={<AmaMediaEntries />} />
							<Route path="ama_media/settings" element={<AmaMediaSettings />} />
							<Route path="ama_media/stats" element={<AmaMediaStats />} />
							<Route path="backup" element={<Backup />} />
							<Route path=":app_uid/file_manager" element={<DashboardFileManager />} />
							<Route exact path=":app_uid/eras/:id" element={<DashboardEra />} />
							<Route exact path=":app_uid/sections" element={<DashboardSections />} />
							<Route exact path=":app_uid/sections/:id" element={<DashboardSection />} />
							<Route exact path=":app_uid/popups" element={<DashboardPopups />} />
							<Route exact path=":app_uid/popups/:id" element={<DashboardPopup />} />
							<Route exact path=":app_uid/maps" element={<DashboardMaps />} />
							<Route exact path=":app_uid/maps/:id" element={<DashboardMap />} />
						</Route>
					</Routes>
				</UserProvider>
			</ModalsProvider>
		</Router>
	);
}
